import React from "react"
import { Avatar } from "material-ui"
import ImageLoader from "../misc/ImageLoader"
import ToolTip from "react-portal-tooltip"

interface IProps {
    thumbnailId: string
    imageS3Url: string
    thumbnailSize: number
}
interface IState {
    open: boolean
}

export default class Thumbnail extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            open: false
        }
    }

    render() {
        if (!this.props.imageS3Url)
            return null
        return (
            <div>
                <ToolTip
                    active={this.state.open}
                    position="right"
                    arrow="center"
                    parent={`#Thumbnail-${this.props.thumbnailId}`}
                    tooltipTimeout={50}
                >
                    <div style={{ height: 250, minWidth: 150 }}>
                        <ImageLoader url={this.props.imageS3Url} fixedHeight={250} />
                    </div>
                </ToolTip>
                <Avatar
                    id={`Thumbnail-${this.props.thumbnailId}`}
                    src={this.props.imageS3Url}
                    size={this.props.thumbnailSize}
                    onClick={() => this.setState({ open: !this.state.open })}
                    onMouseOut={() => this.setState({ open: false })}
                />
            </div>
        )
    }
}
